<div class="content-block">

  <!-- Content Header (Page header) -->

  <div class="content-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          <h1 class="m-0 text-dark">Magazzino</h1>
        </div><!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
            <li class="breadcrumb-item">Magazzino</li>
            <li class="breadcrumb-item active">Giacenze DPI</li>
          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->
</div>

<div class="content-block">


  <section class="col-lg-12 ">

    <div class="card primary">
      <div class="card-header">
        <h3 class="card-title">
          <i class="fa fa-chart-pie mr-1"></i>
          Giacenze DPI
        </h3>

      </div><!-- /.card-header -->
      <div class="card-body">
        <dx-data-grid
          [dataSource]="dataSource"
          [showBorders]="true"
          [focusedRowEnabled]="true"
          [focusedRowIndex]="0"
          [columnAutoWidth]="true"
          [columnHidingEnabled]="true"
          [showColumnLines]="true"
          [showRowLines]="true"
          [rowAlternationEnabled]="true"
          [masterDetail]="{ enabled: true, template: 'detail' }">

          <dxo-editing
            mode="row"
            [allowAdding]="true"
            [allowUpdating]="true"
            [allowDeleting] ="true"
            [useIcons]="true">
          </dxo-editing>

          <dxo-paging [pageSize]="10"></dxo-paging>
          <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxi-column type="buttons" [buttons]="['edit', 'delete']"></dxi-column>
          <dxi-column
            dataField="id"
            [formItem]="{ visible: false }"
            [visible]="false"
            [allowEditing]="false">
          </dxi-column>

          <dxi-column
            name="addFile"
            [formItem]="{ visible: false }"
            dataField="id" [allowFiltering]="false"
            width="30"
            [allowSorting]="false" cellTemplate="linkCellTemplate"
            caption="">
          </dxi-column>
          <dxi-column
            dataField="codice">
          </dxi-column>
          <dxi-column
            dataField="descrizione">
          </dxi-column>
          <dxi-column
            dataField="giacenza">
          </dxi-column>
          <dxi-column
            dataField="totCarichi">
          </dxi-column>
          <dxi-column
            dataField="totScarichi">
          </dxi-column>
          <dxi-column
            dataField="idTipo">
            <dxo-lookup [dataSource]="listTipiArticoli" valueExpr="id" displayExpr="descrizione"></dxo-lookup>
          </dxi-column>


          <div *dxTemplate="let d of 'linkCellTemplate'">
            <i (click)="goToAllega(d.value)" style="cursor: pointer;" class="dx-icon-upload" data-toggle="tooltip" data-placement="top" title="Allega documento"></i>
          </div>

          <div *dxTemplate="let dpi of 'detail'">
            <div class="master-detail-caption">{{"Allegati del dpi " + dpi.data.codice}}</div>
            <dx-data-grid
              [dataSource]="getAllegati(dpi.data.id)"
              [showBorders]="true"
              [columnAutoWidth]="true">
              <dxi-column dataField="id"></dxi-column>
              <dxi-column dataField="nome"></dxi-column>
              <dxi-column
                name="scaricaFile"
                [allowFiltering]="false"
                [allowSorting]="false" cellTemplate="scaricaFile"
                caption="">
              </dxi-column>
              <dxi-column
                name="vediFile"
                [allowFiltering]="false"
                [allowSorting]="false" cellTemplate="vediFile"
                caption="">
              </dxi-column>
              <dxi-column
                name="deleteFile"
                [allowFiltering]="false"
                [allowSorting]="false" cellTemplate="deleteFile"
                caption="">
              </dxi-column>
              <div *dxTemplate="let d of 'scaricaFile'">
                <i class="dx-icon-download"
                (click)="scaricaFile(d.data)" style="cursor: pointer;" data-toggle="tooltip" data-placement="top" title="Scarica allegato"></i>
              </div>
              <div *dxTemplate="let d of 'vediFile'">
                @if (endsWith(d.data.nomeFile, '.jpg') || endsWith(d.data.nomeFile, '.png')) {
                  <i class="dx-icon-image"
                  (click)="visualizzaImmagine(d.data)" style="cursor: pointer;" data-toggle="tooltip" data-placement="top" title="Visualizza immagine"></i>
                }
                @if (endsWith(d.data.nomeFile, '.pdf')) {
                  <i class="dx-icon-doc"
                  (click)="visualizzaFile(d.data)" style="cursor: pointer;" data-toggle="tooltip" data-placement="top" title="Visualizza allegato"></i>
                }
              </div>
              <div *dxTemplate="let d of 'deleteFile'">
                <i class="dx-icon-trash"
                (click)="eliminaFile(d.data)" style="cursor: pointer;" data-toggle="tooltip" data-placement="top" title="Elimina allegato"></i>
              </div>
            </dx-data-grid>
          </div>

        </dx-data-grid>
      </div><!-- /.card-body -->
    </div>
    <!-- /.card -->

  </section>


  <!--<h2 class="content-block">Tabella Dpi</h2>
  <div class="content-display">

  </div>-->
</div>
<dx-popup
  [width]="600"
  [height]="450"
  [showTitle]="true"
  title="Information"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [(visible)]="popupImageVisible">
  <img style="max-width: 100%; max-height: 100%;" [src]="currentImage" alt="Immagine Allegato Articolo">
</dx-popup>
